import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Icon,
  Avatar,
  Typography,
} from '@material-ui/core';
import * as brandColors from '../../../utils/brand-colors';
import styles from './styles';

class DisplayMessage extends React.Component {
  render() {
    const {
      classes,
      icon,
      title,
      subTitle,
      color,
      iconColor,
    } = this.props;
    return (
      <div className={classes.messageContainer}>
        <Avatar className={classes.messageAvatar} style={{ backgroundColor: color || brandColors.grey[200] }}>
          <Icon className={classes.messageAvatarIcon} style={{ color: iconColor || brandColors.grey[800] }}>{icon}</Icon>
        </Avatar>
        <Typography component="h1" variant="h3">
          {title}
        </Typography>
        <Typography component="h1" variant="subtitle1">
          {subTitle}
        </Typography>
      </div>
    );
  }
}

DisplayMessage.propTypes = {
  classes: PropTypes.object,
  title: PropTypes.string,
  subTitle: PropTypes.any,
  icon: PropTypes.string,
  color: PropTypes.string,
  iconColor: PropTypes.string,
};

DisplayMessage.defaultProps = {
  classes: {},
  title: '',
  subTitle: '',
  icon: '',
  color: 'default',
  iconColor: '#858585',
};

export default withStyles(styles)(DisplayMessage);
